export default "<ngx-ui-loader></ngx-ui-loader>\n<router-outlet><app-spinner></app-spinner></router-outlet>\n"